/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useState} from "react";
import {
    AutoAwesomeMotionOutlined,
    AutoStoriesOutlined,
    BadgeOutlined,
    FastForwardOutlined,
    TableRestaurantOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Config_Mesas from "./Secciones/Seccion_Config_Mesas";
import Seccion_Mesas_Dia from "./Secciones/Seccion_Mesas_Dia";
import Seccion_Reservaciones from "./Secciones/Seccion_Reservaciones";
import Seccion_Fila from "./Secciones/Seccion_Fila";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)

    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    return (
        <Grid
            container
            size={12}
        >

            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>


        </Grid>
    )

}
export default Dashboard

let secciones = [
    {
        nombre: 'Mesas',
        icono: TableRestaurantOutlined,
        camino: '/Mesas',
        categoria: 'Inicio',
        Componente: <Seccion_Mesas_Dia/>
    },
    {
        nombre: 'Fila',
        icono: FastForwardOutlined,
        camino: '/Fila',
        categoria: 'Inicio',
        Componente: <Seccion_Fila/>
    },
    {
        nombre: 'Reservaciones',
        icono: AutoStoriesOutlined,
        camino: '/Reservaciones',
        categoria: 'Inicio',
        Componente: <Seccion_Reservaciones/>
    },
    {
        nombre: 'Config Mesas',
        icono: AutoAwesomeMotionOutlined,
        camino: '/ConfigMesas',
        categoria: 'Configuraciones',
        Componente: <Seccion_Config_Mesas/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Usuarios/>
    }
];


const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}